var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 15.333C5 14.3902 5 13.9188 5.29289 13.6259C5.58579 13.333 6.05719 13.333 7 13.333H33C33.9428 13.333 34.4142 13.333 34.7071 13.6259C35 13.9188 35 14.3902 35 15.333V19.6663C35 20.6091 35 21.0806 34.7071 21.3734C34.4142 21.6663 33.9428 21.6663 33 21.6663H32C31.0572 21.6663 30.5858 21.6663 30.2929 21.9592C30 22.2521 30 22.7235 30 23.6663V31.333C30 32.2758 30 32.7472 29.7071 33.0401C29.4142 33.333 28.9428 33.333 28 33.333H12C11.0572 33.333 10.5858 33.333 10.2929 33.0401C10 32.7472 10 32.2758 10 31.333V23.6663C10 22.7235 10 22.2521 9.70711 21.9592C9.41421 21.6663 8.94281 21.6663 8 21.6663H7C6.05719 21.6663 5.58579 21.6663 5.29289 21.3734C5 21.0806 5 20.6091 5 19.6663V15.333Z",
    stroke: "#292D32",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 21.667H31.6666",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.667L20 33.3337",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 11.6667L17.6694 9.33618C16.4619 8.12865 14.9898 7.21886 13.3698 6.67884L10.9657 5.87748C9.67064 5.4458 8.33325 6.40974 8.33325 7.77485V10.2251C8.33325 11.086 8.88411 11.8503 9.7008 12.1225L13.3333 13.3333",
    stroke: "#0008C3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 11.6667L22.3306 9.33618C23.5381 8.12865 25.0102 7.21886 26.6302 6.67884L29.0343 5.87748C30.3294 5.4458 31.6667 6.40974 31.6667 7.77485V10.2251C31.6667 11.086 31.1159 11.8503 30.2992 12.1225L26.6667 13.3333",
    stroke: "#0008C3",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/gift_icon.1eb0b4e05e8a78d98a17e4422218f011.svg";
export { ForwardRef as ReactComponent };